import ForumPostRequestResource from "common/resources/Project/Config/Forum/ForumPostRequestResource";
import ForumPostResponseResource from "common/resources/Project/Config/Forum/ForumPostResponseResource";
import BasePostIdApi from "./BasePostIdApi";
import { createFormData } from "utils/FormData";

export default class PostIdApi extends BasePostIdApi {
	/**
	 * @description Get by post id
	 */
	public async getByPostId(projectId: string, postId: string): Promise<ForumPostResponseResource> {
		return this.getRequest<ForumPostResponseResource>(this.getBaseUrl({ projectId, postId })).then((response) => ForumPostResponseResource.hydrate(response));
	}

	/**
	 * @description Download a post image
	 */
	public async downloadImage(projectId: string, postId: string): Promise<Blob> {
		return this.getBlobRequest(`${this.getBaseUrl({ projectId, postId })}/image`);
	}

	/**
	 * @description Update a post for a project
	 */
	public async update(projectId: string, postId: string, request: ForumPostRequestResource, image?: File): Promise<ForumPostResponseResource> {
		const formData = createFormData(request);

		if (image) formData.append("file", image);

		return this.putRequestFormdata<ForumPostResponseResource>(this.getBaseUrl({ projectId, postId }), formData).then((response) => ForumPostResponseResource.hydrate(response));
	}

	/**
	 * @description Archive a post
	 */
	public async archive(projectId: string, postId: string): Promise<ForumPostResponseResource> {
		return this.putRequest<ForumPostResponseResource>(`${this.getBaseUrl({ projectId, postId })}/archive`).then((response) => ForumPostResponseResource.hydrate(response));
	}

	/**
	 * @description Restore an archived post
	 */
	public async restore(projectId: string, postId: string): Promise<ForumPostResponseResource> {
		return this.putRequest<ForumPostResponseResource>(`${this.getBaseUrl({ projectId, postId })}/restore`).then((response) => ForumPostResponseResource.hydrate(response));
	}

	/**
	 * @description Delete a post
	 */
	public async delete(projectId: string, postId: string): Promise<void> {
		return this.deleteRequest(`${this.getBaseUrl({ projectId, postId })}`);
	}
}
